export const chartDefaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
};
